// extracted by mini-css-extract-plugin
export default {"rating":"XL-z","numberOfStars":"YL-z","count":"ZL-z","barGraphSpacing":"_L-z","barGraph":"aM-z"};